export const DocumentLifecycleStatus = {
  ACTIVE: "ACTIVE",
  OBSOLETE: "OBSOLETE",
};

export const isDocumentObsolete = (status) =>
  typeof status === "string" &&
  status.toUpperCase() === DocumentLifecycleStatus.OBSOLETE;
